/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRecordMail = createReactComponent("record-mail", "IconRecordMail", [
  ["path", { d: "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M7 15l10 0", key: "svg-2" }]
]);

export { IconRecordMail as default };
//# sourceMappingURL=IconRecordMail.js.map
